import { useRef, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import "./CardLaboratorio.css";
import TildeIcon from "../../../assets/images/generico/TildeIcon";
import PdfIcon from "../../../assets/images/generico/PdfIcon";
import WarningIcon from "../../../assets/images/generico/WarningIcon";
import AlertIcon from "../../../assets/images/generico/AlertIcon";
import PdfIconDisabled from "../../../assets/images/generico/PdfIconDisabled";
import {
  resetBase64Labo,
  wsGetResultadoLaboratorio,
} from "../../../context/Actions/misLaboratorios/misLaboratorios";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import DescargarIcon from "../../../assets/images/generico/DescargarIcon";
import { detectarNavegador } from "../../../../global/utils/detectarNavegador";
import { detectarIOS } from "../../../../global/utils/detectarIOS";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { FileOpener } from "@capacitor-community/file-opener";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { Device } from "@capacitor/device";
import Tooltip from "../../../../global/component/Genericos/Tooltip/Tooltip";
import EnviarMailIcon from "../../../assets/images/generico/EnviarMailIcon";
import { GlobalContext } from "../../../../global/context/Provider";
import { getStrDateYear } from "global/utils/diasData";
import camelize from "global/utils/camelize";

const CardLaboratorio = ({ item }) => {
  const { modalDispatch, misLaboratoriosDispatch, selectDropDownState } =
    useContext(PortalContext);

  const { authState, toasterDispatch } = useContext(GlobalContext);
  const trackButton = useRef();
  const fechaHoy = new Date();
  const ua = navigator.userAgent || "";

  const downloadiOSFileNative = (base64Data) => {
    const b64Data = base64Data;
    const fileName = `Informe-${item.codigo}.pdf`;
    Filesystem.writeFile({
      path: fileName,
      data: b64Data,
      directory: Directory.Documents,
    }).then((c) => {
      const rutaGuardado = c.uri;
      try {
        const fileOpenerOptions = {
          filePath: rutaGuardado,
          contentType: "application/pdf",
          openWithDefault: true,
        };
        FileOpener.open(fileOpenerOptions);
      } catch (e) {
        console.log("Error opening file", e);
      }
    });
  };

  const currentDate = new Date().toLocaleString().replace(/[,:\s\/]/g, "-");
  const downloadPdfAndroidNative = (base64Data) => {
    const b64Data = base64Data;
    const fileName = `Informe-${currentDate}.pdf`;
    Filesystem.writeFile({
      path: `Download/${fileName}`,
      data: b64Data,
      directory: Directory.ExternalStorage,
    }).then((c) => {
      const rutaGuardado = c.uri;
      try {
        const fileOpenerOptions = {
          filePath: rutaGuardado,
          contentType: "application/pdf",
          openWithDefault: true,
        };
        FileOpener.open(fileOpenerOptions);
      } catch (e) {
        console.log("Error opening file", e);
      }
    });
  };

  const blobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result || "";
        const base64 = result.toString().split(",")[1] || "";
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

  const dissmiss = () => {
    hideModal()(modalDispatch);
    resetBase64Labo()(misLaboratoriosDispatch);
  };

  const modalAvisoNavegador = () => {
    showModal(
      "Genericos/DeteccionNavegador/DeteccionNavegador",
      {},
      [],
      "centro",
      false
    )(modalDispatch);
  };

  const informePdf = (idProtocolo) => {
    wsGetResultadoLaboratorio(idProtocolo, verPDF)(misLaboratoriosDispatch);
  };

  const verPDF = (isCorrect, data) => {
    if (isCorrect) {
      showModal(
        "Genericos/InformePDF/InformePDFLabo",
        {
          titulo: `Informe de Laboratorio`,
          dissmiss: dissmiss,
          blob: data?.blob,
        },
        [],
        "centro",
        true
      )(modalDispatch);
    } else {
      showToaster(
        {
          texto: data
            ? data
            : "En este momento no se puede ver/descargar el informe",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      hideModal()(modalDispatch);
    }
  };

  const modalInformePdf = (idProtocolo) => {
    const sBrowser = detectarNavegador();
    const isIOS = detectarIOS();
    if (isIOS) {
      if (sBrowser !== "GoogleChrome") {
        informePdf(idProtocolo);
      } else {
        modalAvisoNavegador();
      }
    } else {
      informePdf(idProtocolo);
    }
  };

  const descargarPDF = (idProtocolo) => {
    const sBrowser = detectarNavegador();
    const isIOS = detectarIOS();
    if (isIOS) {
      if (sBrowser !== "GoogleChrome") {
        wsGetResultadoLaboratorio(
          idProtocolo,
          crearPDF
        )(misLaboratoriosDispatch);
      } else {
        modalAvisoNavegador();
      }
    } else {
      wsGetResultadoLaboratorio(idProtocolo, crearPDF)(misLaboratoriosDispatch);
    }
  };

  const crearPDF = async (isCorrect, data) => {
    if (isCorrect) {
      const { blob } = data || {};
      const isIOS = detectarIOS();
      if (isIOS) {
        Device.getInfo().then(async (info) => {
          if (info.platform === "web") {
            const objectUrl = URL.createObjectURL(blob);
            const descarga = document.createElement("a");
            descarga.href = objectUrl;
            descarga.target = "_blank";
            descarga.download = `Informe-${item.codigo}.pdf`;
            document.body.appendChild(descarga);
            descarga.click();
            document.body.removeChild(descarga);
            URL.revokeObjectURL(objectUrl);
          } else {
            const b64Data = await blobToBase64(blob);
            downloadiOSFileNative(b64Data);
          }
        });
      } else {
        Device.getInfo().then(async (info) => {
          const isGoogleAppWebView = /GSA/.test(ua);
          if (isGoogleAppWebView) {
            const b64Data = await blobToBase64(blob);
            const url = `data:application/pdf;base64,${b64Data}`;
            window.open(url, "_blank");
          } else {
            if (info.platform === "web") {
              const objectUrl = URL.createObjectURL(blob);
              const descarga = document.createElement("a");
              descarga.href = objectUrl;
              descarga.target = "_blank";
              descarga.download = `Informe-${item.codigo}.pdf`;
              document.body.appendChild(descarga);
              descarga.click();
              document.body.removeChild(descarga);
              URL.revokeObjectURL(objectUrl);
            } else {
              const b64Data = await blobToBase64(blob);
              downloadPdfAndroidNative(b64Data);
            }
          }
        });
      }
      resetBase64Labo()(misLaboratoriosDispatch);
    } else {
      showToaster(
        {
          texto: data ? data : "Error al descargar PDF",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  const enviarLaboratorioPorMail = () => {
    const { pacienteElegido } = selectDropDownState.selectDropDown.selectGlobal;
    showModal(
      "Genericos/EnviarMailModal/EnviarMailModal",
      {
        paciente: pacienteElegido
          ? pacienteElegido.paciente
          : authState.auth.data.paciente,
        idProtocolo: item.codigo,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  return (
    <div className="ptur-misLaboratorios-card" ref={trackButton}>
      <div
        className={
          item.validado === false && item.validaparcial === false
            ? "ptur-misLaboratorios-tituloPendiente"
            : "ptur-misLaboratorios-titulo"
        }
      >
        <p className="rb18b">
          {getDiaStrTurno(item.fechaestudio)}{" "}
          <span className="rb18l">
            {getDiaStrTurno(item.fechaestudio, true)}
          </span>
        </p>
      </div>

      <div className="ptur-misLaboratorios-card-cuerpo">
        <li className="ptur-misLaboratorios-turnoSolicitado rb18l">
          Solicitado por:{" "}
          <span className="rb18b">{camelize(item.medsolicitante_desc)}</span>
        </li>
        <li className="ptur-misLaboratorios-turnoSolicitado rb18l">
          Fecha de entrega:{" "}
          <span className="rb18b">
            {new Date(item.fechaentrega).toLocaleDateString("es-AR", {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit",
            })}
          </span>
        </li>
      </div>

      {item.validado === false && item.validaparcial === false && (
        <div className="ptur-MisLaboratorios-lineaDeTiempo-container">
          <hr className="ptur-MisLaboratorios-lineaDeTiempo" />
          <div className="ptur-MisLaboratorios-puntos-container">
            <div className="ptur-MisLaboratorios-punto-texto">
              <div className="MisLaboratorios-texto-linea">
                <p className="ptur-MisLaboratorios-texto rb12l">
                  Día de atención
                </p>
                <p className="ptur-MisLaboratorios-texto rb12b">
                  {getStrDateYear(new Date(item.fechaestudio))}
                </p>
              </div>
              <div className="ptur-MisLaboratorios-punto" />
            </div>

            {fechaHoy < new Date(item.fechaentrega) ? (
              <>
                <div className="ptur-MisLaboratorios-punto-texto2">
                  <div className="MisLaboratorios-texto-linea">
                    <p className="ptur-MisLaboratorios-texto rb12l">Hoy</p>
                    <p className="ptur-MisLaboratorios-texto rb12b">
                      {getStrDateYear(new Date())}
                    </p>
                  </div>
                  <div className="ptur-MisLaboratorios-punto" />
                </div>
                <div className="ptur-MisLaboratorios-punto-texto3">
                  <div className="MisLaboratorios-texto-linea">
                    <p className="ptur-MisLaboratorios-texto rb12l">
                      Fecha de entrega
                    </p>
                    <p className="ptur-MisLaboratorios-texto rb12b">
                      {getStrDateYear(new Date(item.fechaentrega))}
                    </p>
                  </div>
                  <div className="ptur-MisLaboratorios-punto" />
                </div>
              </>
            ) : (
              <>
                <div className="ptur-MisLaboratorios-punto-texto2">
                  <div className="MisLaboratorios-texto-linea">
                    <p className="ptur-MisLaboratorios-texto rb12l">
                      Fecha de entrega
                    </p>
                    <p className="ptur-MisLaboratorios-texto rb12b">
                      {getStrDateYear(new Date(item.fechaentrega))}
                    </p>
                  </div>
                  <div className="ptur-MisLaboratorios-punto" />
                </div>
                <div className="ptur-MisLaboratorios-punto-texto3">
                  <div className="MisLaboratorios-texto-linea-fin">
                    <p className="ptur-MisLaboratorios-texto rb12l">Hoy</p>
                    <p className="ptur-MisLaboratorios-texto rb12b">
                      {getStrDateYear(new Date())}
                    </p>
                  </div>
                  <div className="ptur-MisLaboratorios-punto" />
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {(item.validado === true || item.validaparcial === true) && (
        <hr className="ptur-misLaboratorios-separador" />
      )}

      <div className="ptur-misLaboratorios-cajas-estudio-visualizar">
        <Tooltip
          customCss={"ptur-misLaboratorios-icono-tooltip"}
          descripcion={"Descargar informe"}
          data={
            <div
              className={
                item.validado === false && item.validaparcial === false
                  ? "ptur-misLaboratorios-iconoDescargarDisabled"
                  : "ptur-misLaboratorios-iconoDescargar"
              }
              onClick={
                item.validado === false && item.validaparcial === false
                  ? () => {}
                  : () => descargarPDF(item.codigo)
              }
            >
              <DescargarIcon
                color={
                  item.validado === false && item.validaparcial === false
                    ? "#d9d9d9"
                    : "#006199"
                }
                width={20}
                height={20}
              />
            </div>
          }
        />
        <Tooltip
          customCss={"ptur-misLaboratorios-iconoEnviarMail-tooltip"}
          descripcion={"Enviar informe por email"}
          data={
            <div
              className="ptur-misLaboratorios-iconoCompartir"
              onClick={() => enviarLaboratorioPorMail()}
            >
              <EnviarMailIcon color="var(--color-latex30)" width={20} />
            </div>
          }
        />
        <Tooltip
          descripcion={"Ver informe"}
          customCss={"ptur-misLaboratorios-iconoVerInforme-tooltip"}
          data={
            <div
              className={
                item.validado === false && item.validaparcial === false
                  ? "ptur-misLaboratorios-verEstudioDisabled rb16m c-grey85"
                  : "ptur-misLaboratorios-verEstudio rb16m c-latex30"
              }
              onClick={
                item.validado === true || item.validaparcial === true
                  ? typeof window.orientation !== "undefined"
                    ? () => descargarPDF(item.codigo)
                    : () => modalInformePdf(item.codigo)
                  : () => {}
              }
            >
              {item.validado === false && item.validaparcial === false ? (
                <>
                  <span>
                    <PdfIconDisabled />
                  </span>
                  <button className="btn-disabled-misLaboratorios rb16m c-grey85 bgc-white">
                    Ver Estudio
                  </button>
                </>
              ) : (
                <PdfIcon />
              )}
            </div>
          }
        />
      </div>
      <div className="ptur-misLaboratorios-resultados">
        {item.validado === true || item.validaparcial === true ? (
          item.validaparcial === false ? (
            <>
              <span className="ptur-misLaboratorios-tilde">
                <TildeIcon color={"var(--color-broccoli)"} />
              </span>
              <p className="rb14m ptur-misLaboratorios-tilde-texto">
                Tus resultados están completos
              </p>
            </>
          ) : (
            <>
              <span className="ptur-misLaboratorios-alerta">
                <AlertIcon color={"var(--color-latex30)"} />
              </span>
              <p className="rb14m ptur-misLaboratorios-alerta-texto">
                Tus resultados están parciales
              </p>
            </>
          )
        ) : fechaHoy < new Date(item.fechaentrega) ? (
          <>
            <span className="ptur-misLaboratorios-incompleto">
              <WarningIcon color="#FF6600" />
            </span>
            <p className="rb14m ptur-misLaboratorios-incompleto-texto">
              Tus resultados están pendientes
            </p>
          </>
        ) : (
          <>
            <span className="ptur-misLaboratorios-incompleto">
              <WarningIcon color="var(--color-danger)" />
            </span>
            <p className="rb14m ptur-misLaboratorios-demorado-texto">
              Tus resultados están demorados
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default CardLaboratorio;
